import React, { useState } from "react";
import { Link, Redirect } from "react-router-dom";
import { useDispatch } from "react-redux";
import axios from "axios";
import { logIn } from "../../utils/login";

import { useToasts } from "react-toast-notifications";

const API_URL = process.env.REACT_APP_API_URL;

const AdminLogin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [redirect, setRedirect] = useState(false);
  const { addToast } = useToasts();
  const dispatch = useDispatch();

  const handleSubmit = (event) => {
    event.preventDefault();

    axios
      .post(`${API_URL}/api/auth/admin-login`, { username, password })
      .then((res) => {
        if (res.status === 200) {
          logIn(res.data.token);
          dispatch({ type: "LOGINADMIN" });
          addToast(`${res.data.message}`, {
            appearance: "success",
            autoDismiss: true,
          });
          setRedirect(true);
        }
      })
      .catch((err) =>
        addToast(`Erreur : ${err.message}`, {
          appearance: "error",
          autoDismiss: true,
        })
      );
  };

  return (
    <div>
      {redirect && <Redirect to="/backoffice/home" />}
      <form onSubmit={handleSubmit}>
        <div>
          <div>
            <h2>Connexion</h2>
            <div>
              <div>
                <input
                  type="text"
                  placeholder="Identifiant"
                  value={username}
                  onChange={(event) => {
                    setUsername(event.target.value);
                  }}
                  required
                />
              </div>
            </div>
            <div>
              <div className="div">
                <input
                  type="password"
                  placeholder="Mot de passe"
                  value={password}
                  onChange={(event) => {
                    setPassword(event.target.value);
                  }}
                  required
                />
              </div>
            </div>
            <button
              type="submit"
              className="btn button-envoyer"
              value="Se connecter"
            >
              Se connecter
            </button>
          </div>
          <Link to={"reset-mdp"}>Mot de passe oublié</Link>
        </div>
      </form>
    </div>
  );
};

export default AdminLogin;
